import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { styled } from 'styled-components';
import theme from '../../styles/theme';
import NaviText from './NaviText';
import { useQuery, useQueryClient } from 'react-query';
import { useCallback, useEffect, useState } from 'react';
import { useGetAuthInfo, useLogout } from '../../interfaces/auth';
import { Avatar, ClickAwayListener, Fade, Popper } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const MenuHeader = styled.div`
    position: sticky;
    top:0px;
    z-index:100;
    width: 100%;
    height: 50px;
    padding: 0px 2%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${theme.color.black[10]};// #D5CECF;//
    background: ${theme.color.white[100]};
`;

const PopCard = styled.div`
    background: ${theme.color.white[100]};
    border: 1px solid ${theme.color.black[10]};
    border-radius: 8px;
    margin-top: 4px;
    padding: 8px 16px;
    text-align: center;
    > span {
        display: block;
    }
    > a {
        cursor: pointer;
    }
`;

const Navigator = () => {

    const navigate = useNavigate();

    const queryClient = useQueryClient();
    const {data: menuStatus} = useQuery(['MENU_STATUS']);
    const {data: user, isLoading: isUserLoading} = useGetAuthInfo();

    const { mutate } = useLogout();

    const [uOpen, setUOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuIconClick = () => {
        queryClient.setQueryData('MENU_STATUS',!menuStatus);
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setUOpen(!uOpen);
    };

    const handleLogout = useCallback(() => {
        mutate();
    })

    return (
        <MenuHeader>
            <MenuOpenIcon onClick={handleMenuIconClick} style={{cursor:'pointer',marginBottom:2}}/> &nbsp;
            <div style={{flexGrow:1}}><NaviText /></div>
            {(!isUserLoading && user )&&
            <ClickAwayListener onClickAway={()=>setUOpen(false)}>
                <div style={{display:'flex',alignItems:'center',cursor:'pointer'}}>
                    <Avatar onClick={handleClick}>{user && user.user_nm.substr(-2)}</Avatar>
                </div>
            </ClickAwayListener>}
            <Popper open={uOpen} anchorEl={anchorEl} placement='bottom-end' transition sx={{zIndex:101}}>
            {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <PopCard onClick={()=>setUOpen(false)}>
                    <div>
                        <span style={{fontSize:'0.7rem'}}>{user.dept_nm}</span>&nbsp;
                        <span>{user.user_nm}</span>
                    </div>
                    <span>{user.user_no}</span>
                    <span>{user.userTpNm}</span>
                    {/* <span style={{cursor:'pointer'}} onClick={()=>navigate('/admin/setting/password')}>비밀번호 변경</span> */}
                    <div style={{width:'100%', paddingTop:'8px', textAlign:'center', cursor:'pointer'}} onClick={handleLogout}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2.75H18.12C18.9125 2.71467 19.6868 2.9947 20.2734 3.52881C20.86 4.06293 21.2111 4.80763 21.25 5.6V18.4C21.2111 19.1924 20.86 19.9371 20.2734 20.4712C19.6868 21.0053 18.9125 21.2853 18.12 21.25H12" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M15 12H2.78" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2.75 12L6.75 16" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2.75 12L6.75 8" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </PopCard>
            </Fade>
            )}
            </Popper>
        </MenuHeader>
    )
}

export default Navigator;